module.exports = __webpack_public_path__ + "img/switzerland-cerebrovascular-disease-female.861fdb6e.png";